(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeAdvertisingSourceReport', EmployeeAdvertisingSourceReport);

    EmployeeAdvertisingSourceReport.$inject = ['$resource'];

    function EmployeeAdvertisingSourceReport ($resource) {
        var resourceUrl =  'api/report/employee-advertising-source/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
